document.addEventListener("DOMContentLoaded", function () {

    const backButton = document.querySelector('.poppankki-logo-link');
    const referrer = document.referrer;

    if (backButton) {
    // Poppankki logo functionality
    backButton.addEventListener('click', function() {
        if (history.length > 1 && referrer.includes('poppankki.fi')) {
            history.back();
        } else {
            window.location.href = 'https://www.poppankki.fi/';
        }
    });
}
});